import { MessageDescriptor, useIntl } from "react-intl"

export function useConvertTranslatedLabel(options: { label: MessageDescriptor; value: unknown }[]) {
  const intl = useIntl()
  return options.map((option) => ({ ...option, label: intl.formatMessage(option.label) }))
}
